import React from 'react';

import PriceFilter from '../PriceFilter/PriceFilter';
import RoomsAndSpacesFilter from '../RoomsAndSpacesFilter/RoomsAndSpacesFilter';
import FreeCancellationFilter from '../FreeCancellationFilter/FreeCancellationFilter';
import FilterGroupFilters from '../FilterGroupFilters/FilterGroupFilters';

import type {FilterGroupFiltersProps} from '../FilterGroupFilters/FilterGroupFilters';
import type {FilterBarProps} from '../FilterBar/FilterBar';
import {
    PRICE_FILTER_GROUP_ID,
    ROOMSANDSPACES_FILTER_GROUP_ID,
    FREE_CANCELLATION_GROUP_ID,
} from '../../constants/filters';

export type ExtendedProps = Pick<
    FilterBarProps,
    | 'currency'
    | 'customFiltersParams'
    | 'isMobile'
    | 'onCustomFilterUpdate'
    | 'onFilterToggle'
    | 'onMultipleFilterToggle'
    | 'priceFilterOptions'
    | 'priceInputValuesAreValid'
    | 'results'
    | 'selectedFilters'
    | 'updatePriceInputValuesValidity'
>;
export interface FilterGroupContentProps
    extends ExtendedProps,
        FilterGroupFiltersProps {
    isGroupOpen: boolean;
}

export default function FilterGroupContent({
    currency,
    customFiltersParams,
    filters,
    groupId,
    isGroupOpen,
    isMobile,
    onCustomFilterUpdate,
    onFilterToggle,
    onMultipleFilterToggle,
    priceFilterOptions,
    priceInputValuesAreValid,
    rank,
    selectedFilters,
    twoColumns,
    updatePriceInputValuesValidity,
}: FilterGroupContentProps) {
    // Return content based on filter group.
    if (groupId === PRICE_FILTER_GROUP_ID) {
        return (
            <PriceFilter
                currency={currency}
                customFiltersParams={customFiltersParams}
                onCustomFilterUpdate={onCustomFilterUpdate}
                priceFilterOptions={priceFilterOptions}
                priceInputValuesAreValid={priceInputValuesAreValid}
                updatePriceInputValuesValidity={updatePriceInputValuesValidity}
            />
        );
    }

    if (groupId === ROOMSANDSPACES_FILTER_GROUP_ID) {
        return (
            <RoomsAndSpacesFilter
                customFiltersParams={customFiltersParams}
                filters={filters}
                isMobile={isMobile}
                onCustomFilterUpdate={onCustomFilterUpdate}
                onFilterToggle={onFilterToggle}
                resetViewAll={isGroupOpen}
                selectedFilters={selectedFilters}
                twoColumns={twoColumns}
                rank={rank}
            />
        );
    }

    if (groupId === FREE_CANCELLATION_GROUP_ID) {
        return (
            <FreeCancellationFilter
                filters={filters}
                onMultipleFilterToggle={onMultipleFilterToggle}
                selectedFilters={selectedFilters}
                rank={rank}
            />
        );
    }

    return (
        <FilterGroupFilters
            filters={filters}
            groupId={groupId}
            selectedFilters={selectedFilters}
            onFilterToggle={onFilterToggle}
            resetViewAll={isGroupOpen}
            isMobile={isMobile}
            twoColumns={twoColumns}
            rank={rank}
        />
    );
}
